import React, { useState } from 'react';
import { useSubmitForm } from '../../../../hooks/useSubmitForm/useSubmitForm';
import { crearCampanaBeneficiosAPI } from '../../../../consumers/backendApisUrls';
import { usePropsSelect } from '../../../../hooks/useProps/usePropsSelect';
import BaseCampana from './BaseCampana';
import { usePropsInputs } from '../../../../hooks/useProps/usePropsInput';

const CrearCampanha = ({ toggleModal, refreshPage }) => {
  const SECTION_NAME = "CrearNuevaCampana";
  const KEYS = {
    Nombre: "Nombre",
    CuotasPago: "CuotasPago",
    CuotasMax: "CuotasMax",
    DiaCorte: "DiaCorte",
    FechaInicio: "FechaInicio",
    FechaFin: "FechaFin",
    Lineamientos: "LineamientoFile",
    IdPlantilla: "IdPlantilla",
    IdUnidad: "IdUnidad",
    IdCargo: "IdCargo",
    Incluye: "Incluye",
    FechaEnvio: "FechaEnvio",
    VigenciaPedido: "VigenciaPedido",
    ImagenCampania: "ImagenCampaniaFile",
    SignoComparador: "SignoComparador",
    FechaIngreso: "FechaIngreso",
    RequiereDataExterna: "RequiereDataExterna",
    IdTipoEmpleado: "IdTipoEmpleado",
    TextoDescriptivo: "TextoDescriptivo",
    MesesMaximoCuotas: "MesesMaximoCuotas",
    SolicitarNumeroWhatsApp: "SolicitarNumeroWhatsApp",
  };
  const [formValues, setFormValues] = useState({});
  const [allDropdowns, setAllDropdowns] = useState([]);
  const [filas, setFilas] = useState([]);
  const [commonProps] = usePropsInputs(formValues, setFormValues, SECTION_NAME);
  const [selectProps] = usePropsSelect(allDropdowns, formValues, setFormValues, SECTION_NAME);
  const [isLoading, setIsLoading] = useState(true);
  const [isUploading, setIsUploading] = useState(false);
  const [submitForm] = useSubmitForm();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsLoading(true);
    const api = crearCampanaBeneficiosAPI();
    const payload = getPayload();
    try {
      await submitForm(
        Object.values(KEYS),
        api,
        payload,
        SECTION_NAME,
        successSubmit
      );
    } catch (error) {
      console.error(error);
    } finally {
      setIsLoading(false);
    }
  };

  const getPayload = () => {
    const filasPayload = filas.map((row) => {
      return {
        IdsUnidades: row.IdUnidad,
        Incluye: parseInt(row.Incluye),
        IdsCargos: row.IdCargo,
        Tope: parseInt(row.Tope),
        SignoComparador: row.SignoComparador,
        FechaIngreso : row.FechaIngreso,
        IdTipoEmpleado: row.IdTipoEmpleado,
      };
    });
    return {
      ...formValues,      
      Topes: filasPayload,
    };
  }

  const successSubmit = async () => {
    toggleModal();
    await refreshPage();
  };

  return (
    <BaseCampana
      title="Crear nueva campaña"
      toggleModal={toggleModal}
      handleSubmit={handleSubmit}
      puedeEditar={true}
      sectionName={SECTION_NAME}
      filas={filas}
      setFilas={setFilas}
      allDropdowns={allDropdowns}
      setAllDropdowns={setAllDropdowns}
      formValues={formValues}
      setFormValues={setFormValues}
      commonProps={commonProps}
      selectProps={selectProps}
      isLoading={isLoading}
      setIsLoading={setIsLoading}
      isUploading={isUploading}
      setIsUploading={setIsUploading}
      KEYS={KEYS}
    />
  );
};

export default CrearCampanha;